import { takeLatest, call, all, put } from 'redux-saga/effects';
import { auth, handleUserProfile, getCurrentUser } from './../../firebase/utils';
import userTypes from './user.types';
import { signInSuccess, signOutUserSuccess, resetPasswordSuccess, userError, setCustomers, setVendors } from './user.actions';
import {  handleResetPasswordAPI, handleUpdateUser, handleFetchCustomers, handleFetchVendors } from './user.helpers';


export function* getSnapshotFromUserAuth(user, additionalData = {}) {
	try {
	  const userRef = yield call(handleUserProfile, { userAuth: user, additionalData });
	  const snapshot = yield userRef.get();
	  yield put(
		signInSuccess({
		  id: snapshot.id,
		  ...snapshot.data()
		})
	  );
  
	} catch (err) {
	   alert(err)
	}
  }

export function* emailSignIn({ payload: { email, password } }) {
	try {
	  const { user } = yield auth.signInWithEmailAndPassword(email, password);
	  yield getSnapshotFromUserAuth(user);
  
	} catch (err) {
	  alert(err)
	}
}

export function* onEmailSignInStart() {
	yield takeLatest(userTypes.EMAIL_SIGN_IN_START, emailSignIn);
}

export function* isUserAuthenticated() {
	try {
	  const userAuth = yield getCurrentUser();
	  if (!userAuth) return;
	  yield getSnapshotFromUserAuth(userAuth);
  
	} catch (err) {
	  alert(err)
	}
}

export function* onCheckUserSession() {
	yield takeLatest(userTypes.CHECK_USER_SESSION, isUserAuthenticated);
}

export function* signOutUser() {
	try {
	  yield auth.signOut();
	  yield put(
		signOutUserSuccess()
	  )
  
	} catch (err) {
	  alert(err)
	}
}
  
export function* onSignOutUserStart() {
	yield takeLatest(userTypes.SIGN_OUT_USER_START, signOutUser);
}

export function* signUpUser({ payload: {
	EIN,
	contactName,
	contactEmail,
	displayName,
	address,
	address2,
	city,
	state,
	zip,
	phone,
	email,
	userRoles,
	password,
	confirmPassword,
	subscribed,
	fullAddress,
	center
  } }) {
  
	if (password !== confirmPassword) {
	  const err = ['Password Don\'t match'];
	  yield put(
		userError(err)
	  );
	  return;
	}
  
	try {
	  

		
	
	  const { user } = yield auth.createUserWithEmailAndPassword(email, password);
	  const additionalData = { 
		EIN,
		contactName,
		contactEmail,
		
		displayName, 
		address,
		address2,
		city,
		state,
		zip,
		phone,
		userRoles,
		subscribed,
		fullAddress,
		center };
	  yield getSnapshotFromUserAuth(user, additionalData);
  
	} catch (err) {
	  alert(err)
	}
  
}
  
export function* onSignUpUserStart() {
	yield takeLatest(userTypes.SIGN_UP_USER_START, signUpUser);
}

export function* resetPassword({ payload: { email }}) {
	try {
	  yield call(handleResetPasswordAPI, email);
	  yield put(
		resetPasswordSuccess()
	  );
  
	} catch (err) {
	  yield put(
		userError(err)
	  )
	}
}
  
export function* onResetPasswordStart() {
	yield takeLatest(userTypes.RESET_PASSWORD_START, resetPassword);
}

export function* updateUser({ payload: {
	EIN,
	contactName,
	contactEmail,
	displayName,
	address,
	address2,
	city,
	state,
	zip,
	phone,
	subscribed,
	fullAddress,
	center
  } }) {

	try {
	const  id  = auth.currentUser.uid
	const user = { 
		EIN,
		contactName,
		contactEmail,
		displayName,
		address,
		address2,
		city,
		state,
		zip,
		phone,
		subscribed,
		fullAddress,
		center};
		yield handleUpdateUser(id, user);
		yield isUserAuthenticated();
  
	} catch (err) {
		alert(err)
	}
  }
  
  export function* onUpdateUserStart() {
	yield takeLatest(userTypes.UPDATE_USER_START, updateUser);
  }

export function* updateUserSubscription({ payload: {
	subscribed
  } }) {

	try {
	const  id  = auth.currentUser.uid
	const user = { 
		subscribed};
		yield handleUpdateUser(id, user);
		yield isUserAuthenticated();
  
	} catch (err) {
		alert(err)
	}
  }
  
export function* onUpdateUserSubscription() {
	yield takeLatest(userTypes.UPDATE_USER_SUBSCRIPTION, updateUserSubscription);
  }

export function* fetchCustomers({ payload }) {
	try {	
	  const customers = yield handleFetchCustomers( payload);
	  yield put(
		setCustomers(customers)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchCustomersStart() {
	yield takeLatest(userTypes.FETCH_CUSTOMERS_START, fetchCustomers);
}

export function* fetchVendors({ payload }) {
	try {	
	  const vendors = yield handleFetchVendors( payload);
	  yield put(
		setVendors(vendors)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchVendorsStart() {
	yield takeLatest(userTypes.FETCH_VENDORS_START, fetchVendors);
}

export default function* userSagas() {
	yield all([
	  call(onEmailSignInStart),
	  call(onCheckUserSession),
	  call(onSignOutUserStart),
	  call(onSignUpUserStart),
	  call(onResetPasswordStart),
	  call(onUpdateUserStart),
	  call(onFetchCustomersStart),
	  call(onFetchVendorsStart),
	])
  }